import {
  UserStatus,
  EmailSyncStatus,
  EmailDeliveryStatus,
  EmailAliasStatus,
} from '~/graphql/types';

export const isPendingStatus = (
  status: UserStatus | 'Deleted' | undefined,
): boolean =>
  status === UserStatus.Invited ||
  status === UserStatus.InvitedPending ||
  status === UserStatus.Pending;

export const isSuccessEmailDeliveryStatus = (
  status: EmailDeliveryStatus,
): boolean =>
  status === EmailDeliveryStatus.Synced ||
  status === EmailDeliveryStatus.Sending;
export const isErrorEmailDeliveryStatus = (status: EmailDeliveryStatus) =>
  status === EmailDeliveryStatus.Error;
export const isSendingEmailDeliveryStatus = (status: EmailDeliveryStatus) =>
  status === EmailDeliveryStatus.Scheduled;

export enum MAILBOX_TYPE {
  AccountMailbox = 'AccountMailbox',
  AccountMailboxAlias = 'AccountMailboxAlias',
  OfficeMailbox = 'OfficeMailbox',
  OfficeMailboxAlias = 'OfficeMailboxAlias',
  UserMailbox = 'UserMailbox',
  UserMailboxAlias = 'UserMailboxAlias',
}
export const mailboxTypes = [
  MAILBOX_TYPE.AccountMailbox,
  MAILBOX_TYPE.OfficeMailbox,
  MAILBOX_TYPE.UserMailbox,
];
export const aliasMailboxTypes = [
  MAILBOX_TYPE.AccountMailboxAlias,
  MAILBOX_TYPE.OfficeMailboxAlias,
  MAILBOX_TYPE.UserMailboxAlias,
];

export const isSuccessEmailAliasSyncStatus = (status: EmailAliasStatus) =>
  status === EmailAliasStatus.Verified;
export const isSuccessEmailSyncStatus = (status: EmailSyncStatus) =>
  status === EmailSyncStatus.Running ||
  status === EmailSyncStatus.Downloading ||
  // Debatable if this is the right way to handle as running.
  status === EmailSyncStatus.Partial ||
  status === EmailSyncStatus.Initializing ||
  status === EmailSyncStatus.Valid ||
  status === EmailSyncStatus.MigrationResyncNeeded;

export const isErrorEmailSyncStatus = (status: EmailSyncStatus) =>
  status === EmailSyncStatus.InvalidCredentials ||
  status === EmailSyncStatus.Stopped ||
  status === EmailSyncStatus.Exception ||
  status === EmailSyncStatus.SyncError ||
  status === EmailSyncStatus.Invalid;

/** The levels of authorising we have */
export enum AUTHORISE_LEVEL {
  ACCOUNT = 'Account',
  OFFICE = 'Office',
  USER = 'User',
}

export type FileType =
  | '*'
  | 'application/json'
  | 'application/ld+json'
  | 'application/msword'
  | 'application/pdf'
  | 'application/vnd.api+json'
  | 'application/vnd.ms-excel'
  | 'application/vnd.ms-powerpoint'
  | 'application/vnd.oasis.opendocument.text'
  | 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
  | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  | 'application/xml'
  | 'application/zip'
  | 'audio/mpeg'
  | 'audio/ogg'
  | 'image/gif'
  | 'image/apng'
  | 'image/flif'
  | 'image/webp'
  | 'image/x-mng'
  | 'image/jpeg'
  | 'image/png'
  | 'text/csv'
  | 'text/html'
  | 'text/plain'
  | 'text/xml';

export enum FILE_TYPE {
  CSV = 'text/csv',
  JSON = 'application/json',
  PDF = 'application/pdf',
}

export enum PART_OF_DAY {
  MORNING = 'morning',
  AFTERNOON = 'afternoon',
  EVENING = 'evening',
  NIGHT = 'night',
}

/**
 * This prod account allows us to add flow templates that will be available for all accounts in production.
 */
export const MASTER_ACCOUNT_ID = 'a---f4ac6851-fa80-4262-9ace-131ae070be2c';
